import React from "react";
import Hero from "../Components/Hero";
import Intro from "../Components/intro";
import Milestones from "../Components/Milestones";

function Home() {
  return (
    <>
      <Hero />
      <Intro />
      <Milestones />
    </>
  );
}

export default Home;
